import {
  gql,
  OperationVariables,
  QueryHookOptions,
  useQuery,
} from '@apollo/client';

import { IQueryAlertsPaginated } from './types';
import { SuricataAlert } from '@investigator/shared/generated/graphql';

export const QUERY_ALERTS_SURICATA_PAYLOAD = gql`
  query queryAlertsSuricataPayloadPaginated(
    $query: String!
    $offset: Int
    $size: Int
    $sort: [SortParameterInput]
    $log_search_client_session_id: String!
  ) {
    queryAlertsPaginated(
      query: $query
      offset: $offset
      size: $size
      sort: $sort
    ) {
      alerts {
        ... on SuricataAlert {
          uid
          payload
          payload_summary
          session_summary(
            log_search_client_session_id: $log_search_client_session_id
          ) {
            ioc
            alert_summary
            alert_beacons
            unusual_findings
            attack_tactics
          }
        }
      }
      offset
      size
      total_items
    }
  }
`;

export const QUERY_ALERTS_SURICATA_PAYLOAD_LLM_DISABLED = gql`
  query queryAlertsSuricataPayloadLLmDisabledPaginated(
    $query: String!
    $offset: Int
    $size: Int
    $sort: [SortParameterInput]
  ) {
    queryAlertsPaginated(
      query: $query
      offset: $offset
      size: $size
      sort: $sort
    ) {
      alerts {
        ... on SuricataAlert {
          uid
          payload
        }
      }
      offset
      size
      total_items
    }
  }
`;
export const useQueryAlertsSuricataPayload = (
  options: QueryHookOptions<
    IQueryAlertsPaginated<SuricataAlert>,
    OperationVariables
  >,
) => {
  return useQuery<IQueryAlertsPaginated<SuricataAlert>>(
    QUERY_ALERTS_SURICATA_PAYLOAD,
    options,
  );
};
